// https://git.hubteam.com/HubSpot/AutomationPlatform/blob/master/AutomationPlatformBase/src/main/java/com/hubspot/automationplatform/base/validation/FlowValidationErrorType.java
export const AB_EMAIL_MULTIPLE_WORKFLOWS = 'AB_EMAIL_MULTIPLE_WORKFLOWS';
export const ACTION_HAS_MULTIPLE_NON_GOTO_PARENTS = 'ACTION_HAS_MULTIPLE_NON_GOTO_PARENTS';
export const ACTION_NOT_AUTHORIZED = 'ACTION_NOT_AUTHORIZED';
export const BODY_TOO_LONG = 'BODY_TOO_LONG';
export const BRANCH_WITH_TOO_MANY_CONNECTIONS = 'BRANCH_WITH_TOO_MANY_CONNECTIONS';
export const CHANNEL_ID_COUNT_EXCEEDS_LIMIT = 'CHANNEL_ID_COUNT_EXCEEDS_LIMIT';
export const CLASSIC_INVALID_FLOW_CYCLE = 'CLASSIC_INVALID_FLOW_CYCLE';
export const DEPRECATED_ACTION = 'DEPRECATED_ACTION';
export const DUPLICATE_BRANCH_VALUE = 'DUPLICATE_BRANCH_VALUE';
export const EMPTY_BRANCH = 'EMPTY_BRANCH';
export const EMPTY_WORKFLOW = 'EMPTY_WORKFLOW';
export const ENROLL_IN_DISABLED_FLOW = 'ENROLL_IN_DISABLED_FLOW';
export const EXCEEDED_ACTIONS_LIMIT = 'EXCEEDED_ACTIONS_LIMIT';
export const EXCEEDED_FLOWS_LIMIT = 'EXCEEDED_FLOWS_LIMIT';
export const EXTENSION_MISSING_REQUIRED_FIELD = 'EXTENSION_MISSING_REQUIRED_FIELD';
export const INACTIVE_EMAIL_SUBSCRIPTION_TYPE = 'INACTIVE_EMAIL_SUBSCRIPTION_TYPE';
export const INVALID_ACTION_FOR_OBJECT_TYPE = 'INVALID_ACTION_FOR_OBJECT_TYPE';
export const INVALID_ACTION_TYPE = 'INVALID_ACTION_TYPE';
export const INVALID_CONTENT_ID = 'INVALID_CONTENT_ID';
export const INVALID_DELAY_CONFIGURATION = 'INVALID_DELAY_CONFIGURATION';
export const INVALID_EMAIL_ADDRESS = 'INVALID_EMAIL_ADDRESS';
export const INVALID_EMAIL_TYPE = 'INVALID_EMAIL_TYPE';
export const INVALID_EXTENSION_DEFINITION_ID = 'INVALID_EXTENSION_DEFINITION_ID';
export const INVALID_EXTENSION_INSTANCE_ID = 'INVALID_EXTENSION_INSTANCE_ID';
export const INVALID_FLOW_CYCLE = 'INVALID_FLOW_CYCLE';
export const INVALID_FLOW_TYPE = 'INVALID_FLOW_TYPE';
export const INVALID_INPUT_VALUE_FIELD_KEY = 'INVALID_INPUT_VALUE_FIELD_KEY';
export const INVALID_INPUT_VALUE = 'INVALID_INPUT_VALUE';
export const INVALID_LIST_DEFINITION = 'INVALID_LIST_DEFINITION';
export const INVALID_LIST_ID = 'INVALID_LIST_ID';
export const INVALID_LIST_TYPE = 'INVALID_LIST_TYPE';
export const INVALID_OAUTH_CONNECTED_ACCOUNT = 'INVALID_OAUTH_CONNECTED_ACCOUNT';
export const INVALID_PERSONALIZATION_TOKEN = 'INVALID_PERSONALIZATION_TOKEN';
export const INVALID_REFERENCED_DATA_KEY = 'INVALID_REFERENCED_DATA_KEY';
export const INVALID_SET_PROPERTY_VALUE = 'INVALID_SET_PROPERTY_VALUE';
export const INVALID_TEAM_ID = 'INVALID_TEAM_ID';
export const INVALID_URL = 'INVALID_URL';
export const INVALID_USER_ID = 'INVALID_USER_ID';
export const MARKETING_STARTER_ACCESS_OVERRIDE = 'MARKETING_STARTER_ACCESS_OVERRIDE';
export const MAX_ASSOCIATION_LABELS_REACHED = 'MAX_ASSOCIATION_LABELS_REACHED';
export const MISMATCHED_ENUM_OPTIONS = 'MISMATCHED_ENUM_OPTIONS';
export const MISSING_EMAIL_SUBSCRIPTION_TYPE = 'MISSING_EMAIL_SUBSCRIPTION_TYPE';
export const MISSING_FLOW = 'MISSING_FLOW';
export const MISSING_LIST = 'MISSING_LIST';
export const MISSING_RECIPIENTS = 'MISSING_RECIPIENTS';
export const MISSING_REQUIRED_PROPERTIES = 'MISSING_REQUIRED_PROPERTIES';
export const NONEXISTENT_CREATE_OBJECT_TYPE = 'NONEXISTENT_CREATE_OBJECT_TYPE';
export const OVER_WORKFLOWS_LIMIT = 'OVER_WORKFLOWS_LIMIT';
export const PROPERTY_DOES_NOT_EXIST = 'PROPERTY_DOES_NOT_EXIST';
export const REFERENCED_ACTION_NOT_IN_PATH_TO_ACTION = 'REFERENCED_ACTION_NOT_IN_PATH_TO_ACTION';
export const SLACK_INTEGRATION_NOT_INSTALLED = 'SLACK_INTEGRATION_NOT_INSTALLED';
export const SLACK_MISSING_RECIPIENTS = 'SLACK_MISSING_RECIPIENTS';
export const SMS_BODY_TOO_LONG = 'SMS_BODY_TOO_LONG';
export const SUBJECT_TOO_LONG = 'SUBJECT_TOO_LONG';
export const TOO_MANY_SUPPRESSION_LISTS = 'TOO_MANY_SUPPRESSION_LISTS';
export const UNMIGRATED_CLASSIC_BRANCH_LIST = 'UNMIGRATED_CLASSIC_BRANCH_LIST';
export const UNPUBLISHED_CONTENT = 'UNPUBLISHED_CONTENT';
export const UNSUPPORTED_ACTION_TYPE = 'UNSUPPORTED_ACTION_TYPE';
export const UNSUPPORTED_ASSOCIATION = 'UNSUPPORTED_ASSOCIATION';
export const UNSUPPORTED_CREATE_OBJECT_TYPE = 'UNSUPPORTED_CREATE_OBJECT_TYPE';
export const USER_ID_COUNT_EXCEEDS_LIMIT = 'USER_ID_COUNT_EXCEEDS_LIMIT';
export const UNCONFIGURED_ACTION_IN_BRANCH = 'UNCONFIGURED_ACTION_IN_BRANCH';
export const INVALID_ACTION_SCOPE = 'INVALID_ACTION_SCOPE';
export const INVALID_PORTAL_SCOPE = 'INVALID_PORTAL_SCOPE';